import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import { eiwrsKitMetadataServices } from "../../../../APIServices/EIWRS/KitManagement/eiwrsKitMetadataServices";

const UpdateStudyKitMetadata = ({
  kitMetaData,
  getEIWRSKitMetadataData,
  Show,
  Hide,
  Title,
  setKitBatchNumberId,
}) => {
  const { studyId } = useParams()
  const [columnLabel, setColumnLabel] = useState("");
  const [columnName, setColumnName] = useState("");
  const [columnType, setColumnType] = useState("");
  const [isUnique, setIsUnique] = useState("no");
  const [buttonLoader, setButtonLoader] = useState(false);

  const updateEIWRSKitMetadataData = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Kit Metadata!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = kitMetaData?._id;
        userData.studyId = studyId;
        userData.columnLabel = columnLabel;
        userData.columnName = columnName;
        userData.columnType = columnType;
        userData.isUnique = isUnique;
        let data = await eiwrsKitMetadataServices.updateEIWRSKitMetadataData(
          userData
        );
        if (data?.statusCode === 200) {
          getEIWRSKitMetadataData();
          Hide();
        }
      }
      setButtonLoader(false);
    });
  };

  useEffect(() => {
    setColumnLabel(kitMetaData?.columnLabel);
    setColumnName(kitMetaData?.columnName);
    setColumnType(kitMetaData?.columnType);
    setIsUnique(kitMetaData?.isUnique);
  }, [kitMetaData]);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Column Label{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setColumnLabel(e.target.value)}
              value={columnLabel}
              className="br3"
              placeholder="Enter Column Label"
              batchNumber="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Column Name{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => {
                const input = e.target.value
                  .toUpperCase()
                  .replace(/[^A-Z0-9]/g, "");
                setColumnName(input);
              }}
              onKeyDown={(e) => {
                if (e.key === " ") {
                  e.preventDefault();
                }
              }}
              value={columnName}
              className="br3"
              placeholder="Enter Column Name"
              batchNumber="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Column Type{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              value={columnType}
              onChange={(e) => setColumnType(e.target.value)}
              className="br3" style={{ fontSize: 12 }}>
              <option value="">Select Column Type</option>
              <option value="text">Text</option>
              <option value="number">Number</option>
              <option value="date">Date</option>
              <option value="time">Time</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Is Unique{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              value={isUnique}
              onChange={(e) => setIsUnique(e.target.value)}
              className="br3" style={{ fontSize: 12 }}>
              <option value="">Select Is Unique</option>
              <option value="no">No</option>
              <option value="yes">Yes</option>
            </Form.Select>
          </Form.Group>
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm text-end">
          <button
            disabled={!columnLabel || !columnName || !columnType || !isUnique || buttonLoader}
            className="updateProfile"
            onClick={(e) => updateEIWRSKitMetadataData(e)}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Updating...
              </div>
            ) : (
              "Update Metadata"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default UpdateStudyKitMetadata;
